import React, { useState, useEffect } from "react";
import "../Contact.css";
import { send } from "emailjs-com";
import { init } from "emailjs-com";
import DeveloperModeIcon from "@material-ui/icons/DeveloperMode";

init("user_TFuDAynA6OCXOlYL89Wo2");

function Contact() {
  useEffect(() => {
    document.title = "Contact";
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 1);
  }

  useEffect(() => {
    scrollToTop();
  }, [])

  const [toSend, setToSend] = useState({
    from_name: "",
    to_name: "",
    message: "",
    reply_to: "",
  });

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    send(
      "daniel-website",
      "template_t52n019",
      toSend,
      "user_TFuDAynA6OCXOlYL89Wo2"
    )
      .then((response) => {
        console.log("SUCCESS!", response.status, response.text);
      })
      .catch((err) => {
        console.log("FAILED...", err);
      });

    alert("Message is send successfuly!");
    window.location.reload();
  };

  return (
    <div className="contact">
      <h1 className="contact-header">Contact me</h1>
      <div className="container">
        <div className="animate__animated animate__zoomInUp">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-6 contact-img">
              <img
                src={process.env.PUBLIC_URL + "/images/contact/slika.png"}
                alt="Email picture"
              />
            </div>
            <div className="col-md-6 contact-form">
              <center>
                <div className="beta-form">
                  <DeveloperModeIcon />
                  <strong>
                    The form is currently in beta. Please contact me via{" "}
                    <a href="mailto:danielbradaric57@gmail.com">my email.</a>
                  </strong>
                </div>
                <form onSubmit={onSubmit}>
                  <h1>Get in touch with me using following form!</h1>
                  <div className="non-text">
                    <input
                      type="text"
                      name="from_name"
                      placeholder="Your First Name"
                      value={toSend.from_name}
                      onChange={handleChange}
                      required
                    />
                    <input
                      type="hidden"
                      name="to_name"
                      placeholder="to name"
                      value={toSend.to_name}
                      onChange={handleChange}
                    />
                    <input
                      type="email"
                      name="reply_to"
                      placeholder="Your Email"
                      value={toSend.reply_to}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="text">
                    <textarea
                      type="text"
                      name="message"
                      placeholder="Your Message"
                      value={toSend.message}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <button type="submit">Submit</button>
                </form>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
